import Image from 'next/image';
import styled from 'styled-components';

import check from './assets/check.svg';
import inactiveCheck from './assets/inactive-check.svg';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: `checkbox` })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    //box-shadow: 0 0 0 2px #1ac1b5;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? `visible` : `hidden`)};
  }
`;

export type CheckboxProps = {
  checked: boolean;
  setChecked: (value: boolean | { (value: boolean): boolean }) => unknown;
  inactive?: boolean;
};

const Checkbox = (props: CheckboxProps) => {
  const { checked, setChecked, inactive } = props;

  if (inactive) {
    if (checked) {
      return (
        <CheckboxContainer>
          <HiddenCheckbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            disabled={true}
          />
          <StyledCheckbox
            checked={checked}
            className={`rounded-[2px] bg-gray-50`}
          >
            <Image
              width={14}
              height={12}
              src={inactiveCheck}
              className={`visible`}
              alt={`checked`}
            />
          </StyledCheckbox>
        </CheckboxContainer>
      );
    }

    return (
      <CheckboxContainer>
        <HiddenCheckbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          disabled={true}
        />
        <StyledCheckbox
          checked={checked}
          className={`rounded-[2px] border border-gray-100`}
        >
          <Image
            width={14}
            height={12}
            src={inactiveCheck}
            className={`invisible`}
            alt={`checked`}
          />
        </StyledCheckbox>
      </CheckboxContainer>
    );
  }
  if (checked) {
    return (
      <label>
        <CheckboxContainer>
          <HiddenCheckbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <StyledCheckbox
            checked={checked}
            className={`rounded-[2px] bg-green-200 sm:hover:bg-green-300`}
          >
            <Image
              width={14}
              height={12}
              src={check}
              className={`visible`}
              alt={`checked`}
            />
          </StyledCheckbox>
        </CheckboxContainer>
      </label>
    );
  }

  return (
    <label>
      <CheckboxContainer>
        <HiddenCheckbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <StyledCheckbox
          checked={checked}
          className={`rounded-[2px] border border-gray-100 sm:hover:border-[2px] sm:hover:border-green-200`}
        >
          <Image
            width={14}
            height={12}
            src={check}
            className={`invisible`}
            alt={`checked`}
          />
        </StyledCheckbox>
      </CheckboxContainer>
    </label>
  );
};

export default Checkbox;
